(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-extend-modal
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cancel :refer [cancel]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.code :refer [code]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.userDocument :as d-userDocument]
            [teamoesterreich.ajax :as ajax]
    ;;(h/event-value e)
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]))




(defn parse-date [date]
  (log/debug "################### " (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)))
  (js/Date.parse (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8))))


(defn date-conv [date & [or-add-years]]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (if (and (not (nil? date)) (> (count (str date)) 12))
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    (let [now (js/Date.)
          y (.getFullYear now)
          y (if or-add-years (+ or-add-years y) y)
          m (inc (.getMonth now))
          m (if (> m 9) m (str "0" m))
          d (.getDate now)
          d (if (> d 9) d (str "0" d))]
      (str y "-" m "-" d))
    ))

(defn date-conv-add [date add-years]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (if (and (not (nil? date)) (> (count (str date)) 12))
    (str (+ (parse-long (subs date 0 4)) add-years) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    (let [now (js/Date.)
          m (inc (.getMonth now))
          m (if (> m 9) m (str "0" m))
          d (.getDate now)
          d (if (> d 9) d (str "0" d))]
      (str (+ add-years (.getFullYear now)) "-" m "-" d))
    ))

(defn date-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" "120000.000Z"))


(defn >user-edit-field [user-uuid obj cb-fn]
  (ajax/patch> (str backend/BASE_URL "/user/" user-uuid)
               (ajax/serialize (merge {:user-uuid user-uuid}
                                      obj))))

(defn >user-edit-document-field [document-uuid obj cb-fn]
  (ajax/patch> (str backend/BASE_URL "/user/document/" document-uuid)
               (ajax/serialize (merge {:userDocument-uuid document-uuid}
                                      obj))
               cb-fn))


(defn reject-form [!st document]
  (let [!rejectMessage (r/cursor !st [:userDocument-rejectMessage])]
    [mui/grid {:container  true
               :direction  "row"
               :justify    "space-between"
               :spacing    2
               :multiline  true
               :rowsMin    3
               :style      {:paddingRight "5px"}
               :alignItems "flex-start"}
     [mui/grid {:container false :item true :xs 12}
      "Ablehnung Begründung"]
     [mui/grid {:container false :item true :xs 12}
      [mui/text-field {
                       :style           {:background-color (if (:userDocument-rejectMessage @!st) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "text"
                       :autoOk          true
                       :error           (= "" @!rejectMessage)
                       :helper-text     (if (= "" @!rejectMessage) "Bitte Begründung eingeben" "")
                       :onChange        (fn [e] (swap! !st assoc :userDocument-rejectMessage (h/event-value e)))
                       :label           (str " ")
                       :defaultValue    (str "" (:userDocument-rejectMessage @!st))
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]
     ]
    ))


(defn qualification-document-form [!st document]
  (let []
    [mui/grid {:container  true
               :direction  "row"
               :style      {:paddingRight "5px"}
               :error      (< (count (str (:userDocument-type @!st))) 1)
               :justify    "space-between"
               :spacing    2
               :alignItems "flex-start"}
     [mui/grid {:container false :item true :xs 12}
      "Dokument Typ "]
     [mui/grid {:container false :item true :xs 12}
      [mui/select
       {:fullWidth true
        :style     {:background-color (if (:userDocument-type @!st) "#ffd6d2" "#ffffff")}
        :value     (:userDocument-type @!st)
        :onChange  (fn [e]
                     (js/console.log "Change type  -> " (h/event-value e))
                     (swap! !st assoc-in [:userDocument-type] (h/event-value e)))
        }
       (for [[k v] d-userDocument/DOC_TYPES]
         ^{:key (str "docTypes-" k)} [mui/menu-item {:style {} :value k} (:name v)])
       ]]
     [mui/grid {:container false :item true :xs 6}
      [mui/text-field {
                       :style           {:background-color (if (:userDocument-validFrom @!st) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "date"
                       :autoOk          true
                       ;:error           (< (count (str (:userDocument-validFrom @!st))) 1)
                       :onChange        (fn [e] (swap! !st assoc :userDocument-validFrom (h/event-value e)))
                       :label           (str "Gültig von ")
                       :value           (:userDocument-validFrom @!st)
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]
     [mui/grid {:container false :item true :xs 6}
      [mui/text-field {
                       ;:style {:background-color (if (not= (:lrClearance-end @!st) (:lrClearance-end wop-clearance))  "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "date"
                       :style           {:background-color (if (:userDocument-validTo @!st) "#ffd6d2" "#ffffff")}
                       :autoOk          true
                       ;:error           (< (count (str (:userDocument-validTo @!st))) 1)
                       :onChange        (fn [e] (swap! !st assoc :userDocument-validTo (h/event-value e)))
                       :label           (str "Gültig bis ")
                       :value           (if (:userDocument-validTo @!st) (:userDocument-validTo @!st) "")
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]

     [mui/grid {:container false :item true :xs 12}
      [mui/button {:size    "small"
                   :variant "contained"
                   :onClick (fn []
                              (let [newDate (date-conv-add (:userDocument-validFrom @!st) 2)]
                                (log/debug "Add 24 Month " newDate)
                                (swap! !st assoc :userDocument-validTo newDate)))
                   }
       "+ 2 Jahre"]
      ]

     [mui/grid {:container false :item true :xs 12}
      [mui/button {:size    "small"
                   :variant "contained"
                   :onClick (fn []
                              (let [newDate (date-conv-add (:userDocument-validFrom @!st) 5)]
                                (log/debug "Add 5 Years " newDate)
                                (swap! !st assoc :userDocument-validTo newDate)))
                   }
       "+ 5 Jahre"]
      ]

     ])
  )



(defn modal [!actual-user document !show & [!show-doc-assign-modal direct-extend?]]
  (let [{:keys [userDocument-fileName userDocument-path userDocument-type userDocument-uuid userDocument-validFrom userDocument-validTo userDocument-rejected userDocument-rejectMessage uploaded]} document
        !invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        !st (r/atom {:reject                     userDocument-rejected
                     :userDocument-rejectMessage userDocument-rejectMessage
                     :userDocument-type          userDocument-type
                     :userDocument-validFrom     (date-conv userDocument-validFrom 0)
                     :userDocument-validTo       (date-conv userDocument-validTo 0)})
        !reject (r/cursor !st [:reject])
        !rejectMessage (r/cursor !st [:userDocument-rejectMessage])
        !validFrom (r/cursor !st [:userDocument-validFrom])
        !validTo (r/cursor !st [:userDocument-validTo])
        !document-type (r/cursor !st [:userDocument-type])
        active-clearance (d-user/get-active-clearance @!actual-user)
        lrClearance-extendDocument (get-in active-clearance [:lrClearance-extendDocument :userDocument-path])
        is-actual? (= lrClearance-extendDocument userDocument-path)

        {:keys [user-uuid user-tomId user-lastName user-firstName]} @!actual-user]
    (fn []
      (log/debug "actual-user-clearance" (clj->js active-clearance))
      (let [confirmable? (and
                           (not= "" @!document-type)
                           (> (count (str @!validFrom)) 5)
                           (> (count (str @!validTo)) 5)
                           )
            date-to-ok? (< (.getTime (new js/Date)) (parse-date (date-conv-back @!validTo)))]
        ;(reset! !document-type userDocument-type)
        [mui/modal
         {:className        "training-modal"
          :data-clearance   active-clearance
          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (or @!show false)

          }

         [:div
          {
           :class "modal"
           :style {:minWidth 700 :maxWidth 900}}
          [mui/grid {:container  true
                     :direction  "row"
                     :justify    "space-between"
                     :alignItems "flex-start"}
           [mui/grid {:container false :item true :xs 12}
            [:h2
             (if (:userDocument-isTraining document)
               (str "Qualifikationsnachweis für Verlängerung")
               (str "Qualifikationsnachweis für Verlängerung prüfen "))
             ]]

           [mui/grid {:container false :item true :xs 6}
            [:div
             [mui/typography {:style {:wordBreak "break-all"}} "Filename" [:br] (or userDocument-fileName userDocument-path)]
             [:br]
             [mui/typography {:gutterBottom true}
              (if uploaded (str "hochgeladen am: "
                                (subs uploaded 6 8) "." (subs uploaded 4 6) "." (subs uploaded 0 4) " " (subs uploaded 9 10) ":" (subs uploaded 11 13)
                                ) "")]
             [mui/typography {} "Bitte überprüfe:"
              [:br] "Name: " [:a {:href (str "/#user-view$" user-tomId) :target "_blank"} [:span {:style {:color "blue"}} "`" user-lastName ", " user-firstName "`"]]
              [:br] (when-not @!reject [:span (get-in d-userDocument/DOC_TYPES [userDocument-type :tipps])])
              [:br] " "
              [:br]

              (if @!reject
                [reject-form !st document]
                [qualification-document-form !st document])

              [:br] " "
              ]]]

           [mui/grid {:container false :item true :xs 6}
            [:f> backend-file/download-wrapper userDocument-path
             (fn [url]
               (let [url (when url (js/URL. url))]
                 (when url
                   (.set (.-searchParams url) "inline" "true"))
                 [:a {:title "Klick um in neuem Tab zu öffnen"
                      :href  url :target "_blank"}
                  [:div {:style {:position "relative" :float "right"}} "Anlage öffnen"] [:br]
                  [backend-file/img {:hash             userDocument-path
                                            :preview? true
                                            :style    {:position "relative" :float "right" :width "100%" :maxWidth "400px" :maxHeight "600px" :objectFit "contain"} :alt "Ansicht"}]
                  ]))]



            [:br]
            [:br]
            [:br]
            ]


           (when !show-doc-assign-modal
             [mui/grid {:container false :item true :xs 12}
              [mui/button
               {:variant   "contained"
                :startIcon (r/as-element [code])
                :style     {:marginBottom 10}
                :onClick   (fn []
                             (reset! !show-doc-assign-modal {:showTomId @!show :type :training})
                             (reset! !show nil))
                }
               "Dokument wählen"]])


           [mui/grid {:container false :item true :xs 4}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [keyboard-arrow-left])
              :style     {:marginRight 50}
              :onClick   (fn []
                           (reset! !show nil)
                           (reset! !invalidated true))
              }
             "Abbrechen"]]

           (when (not (:userDocument-isTraining document))
             [mui/grid {:container false :item true :xs 4}
              (if @!reject
                [mui/button
                 {:color     "secondary"
                  :variant   "contained"
                  :startIcon (r/as-element [check])
                  :style     {:marginRight 50}
                  :onClick   (fn []
                               (reset! !reject false)
                               (reset! !rejectMessage ""))

                  }
                 "Aufheben"]
                [mui/button
                 {:color     "secondary"
                  :variant   "contained"
                  :startIcon (r/as-element [cancel])
                  :style     {:marginRight 50}
                  :onClick   #(reset! !reject true)
                  }
                 "Ablehnen"])])

           (do
             [mui/grid {:container false :item true :xs 4}
              (if @!reject
                [mui/button
                 {:color     "primary"
                  :style     {:float "right"}
                  :variant   "contained"
                  :disabled  (or (= "" @!rejectMessage) (= userDocument-rejectMessage @!rejectMessage))
                  :startIcon (r/as-element [cancel])
                  :onClick   (fn []
                               (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                                 {:userDocument-readonly      false
                                                                  :userDocument-rejectMessage (:userDocument-rejectMessage @!st)
                                                                  :userDocument-rejected      true
                                                                  :userDocument-locked        false
                                                                  :userDocument-isIdentity    false
                                                                  :userDocument-isSelfExplain false
                                                                  :userDocument-isTraining    false
                                                                  }
                                                                 (fn [])))
                  }
                 "Ablehnen"]

                (if date-to-ok?
                  [mui/button
                   {:color     "primary"
                    :style     {:float "right" :display ()}
                    :variant   "contained"
                    :disabled  (not confirmable?)
                    :startIcon (r/as-element [check])
                    :onClick   (fn []
                                 (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                                   {:userDocument-readonly   true
                                                                    :userDocument-isTraining true
                                                                    :userDocument-validFrom  (date-conv-back (:userDocument-validFrom @!st))
                                                                    :userDocument-validTo    (date-conv-back (:userDocument-validTo @!st))
                                                                    :userDocument-type       (:userDocument-type @!st)
                                                                    }
                                                                   (fn []
                                                                     (when direct-extend?
                                                                       (d-lrClearance/>extend-clearance (:lrClearance-uuid active-clearance)
                                                                                                        {:lrClearance-end      (date-conv-back (:userDocument-validTo @!st))
                                                                                                         :_extendDocument-uuid (:userDocument-uuid document)}
                                                                                                        (fn []
                                                                                                          (d-user/actual-user-invalidate !actual-user)
                                                                                                          (reset! !invalidated true)
                                                                                                          (reset! !show nil)
                                                                                                          ))))
                                                                   )

                                 )
                    }
                   (if direct-extend? "bestätigen und verlängern" "Dokument Bestätigen")
                   ]
                  [mui/chip {:color "primary" :label (str "`Gültig bis` ist ungültig ")}]
                  )
                )
              ])
           ]]]

        ))))

(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn modal-by-tomId [!tomId !documentHash !show-doc-assign-modal]
  (let [!actual-user (r/atom {})]
    (fn []
      (let [user @!actual-user
            tomId @!tomId
            documentHash @!documentHash]
        (when (and (pos? tomId) (not= tomId (:reqTomId user))) (get-user-details !actual-user tomId))
        (if (or (not= @!tomId (:reqTomId user)) (:error user))
          ;no data
          [mui/modal
           {:className        "training-load-modal"
            :aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (pos? tomId)
            :onClose          (fn []
                                (reset! !actual-user {})
                                (reset! !tomId nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}
            [:h4 (str "Qualifikationsnachweis prüfen ")]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !actual-user {})
                          (reset! !tomId nil))
              }
             "Schließen"]
            ]]
          ;has data
          (let [document (first (filter (fn [e] (and (:userDocument-active e) (= (:userDocument-path e) documentHash))) (:user-userDocument @!actual-user)))]
            [modal !actual-user document !tomId !show-doc-assign-modal true]
            )

          )))))